(() => {
  const desktop = window.matchMedia('(min-width: 768px)');

  function initializeFooter(footer) {
    if (!footer || footer.dataset.epReady === 'true') return;

    footer.dataset.epReady = 'true';

    const menus = Array.from(
      footer.querySelectorAll('[data-ep-menu]')
    );

    function updateMenus() {
      menus.forEach((menu) => {
        if (desktop.matches) {
          menu.open = true;
          return;
        }

        menu.open = menu.dataset.mobileOpen === 'true';
      });
    }

    menus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (desktop.matches) return;

        menu.dataset.mobileOpen = menu.open ? 'true' : 'false';

        if (!menu.open) return;

        menus.forEach((otherMenu) => {
          if (otherMenu === menu) return;

          otherMenu.open = false;
          otherMenu.dataset.mobileOpen = 'false';
        });
      });
    });

    footer
      .querySelectorAll('[data-ep-localization]')
      .forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.closest('form');

          if (!form) return;

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });

    updateMenus();

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', updateMenus);
    } else {
      desktop.addListener(updateMenus);
    }
  }

  function initializeAll(context = document) {
    context
      .querySelectorAll('[data-ep-footer]')
      .forEach(initializeFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAll();
    });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();